import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSuccess = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 14 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.24628 6.99576L12.2421 0L13.7388 1.50742L5.24628 10L1 5.75372L2.49683 4.2569L5.24628 6.99576Z",
		fill: "currentColor"
	})
});
export default SvgSuccess;
